<template>
  <b-modal
    id="account-game-modal"
    ref="account-game-modal"
    hide-footer
    :title="title"
    @show="setData"
    @hidden="resetModal"
    size="xl"
    body-class="p-0"
  >
    <div class="card rounded-0 mb-0">
      <div class="card-header">
        <ul class="nav nav-tabs card-header-tabs">
          <li v-for="cat in categories" :key="cat._id" class="nav-item">
            <a class="nav-link" :class="[{'active':setCatId===cat._id}]" href="#" target="_self" @click="setCatId=cat._id">{{ cat.name }}</a>
          </li>
        </ul>
      </div>

      <table class="table table-info table-bordered table-hover table-striped table-sm mb-0">
        <thead>
          <tr>
            <th rowspan="2" width="60">ลำดับ</th>
            <th width="60">เลือก</th>
            <th>ค่ายเกม</th>
            <th width="180">สถานะ</th>
            <th width="140">แบ่งหุ้น</th>
            <th width="140">คอมฯ</th>
            <th width="60"></th>
          </tr>
          <tr v-if="creatorItems.length" class="alert-warning">
            <td class="text-center">
              <b-form-checkbox v-model="checkAll" class="m-0" :value="true" :unchecked-value="false" />
            </td>
            <td class="text-center small">ตั้งค่ากับที่เลือก</td>
            <td class="text-left pl-3">
              <b-form-radio-group
                v-model="bulkData.isAvailable"
                :options="statusOptions"
                stacked
              ></b-form-radio-group>
            </td>
            <td class="align-top text-left">
              <b-form-checkbox
                v-model="checkedShareHolder"
                :value="true"
                :unchecked-value="false"
              >
                ตั้งค่า
              </b-form-checkbox>
              <b-form-select
                style="width: 120px;"
                v-model="bulkData.shareHolder.receive"
                :disabled="!bulkCreatorIds.length || !checkedShareHolder"
                :options="shareOptions"
                size="sm"
              ></b-form-select>
            </td>
            <td class="align-top text-left">
              <b-form-checkbox
                v-model="checkedCommission"
                :value="true"
                :unchecked-value="false"
              >
                ตั้งค่า
              </b-form-checkbox>
              <div class="d-flex justify-content-center">
                <b-form-input
                  size="sm"
                  style="width: 120px;"
                  v-model="bulkData.shareHolder.commission"
                  :disabled="!bulkCreatorIds.length || !checkedCommission"
                  type="number"
                  :number="true"
                >
                </b-form-input>
              </div>
            </td>
            <td class="align-top">
              <button @click="saveBulk" :disabled="!bulkCreatorIds.length" class="btn btn-sm btn-success">บันทึก</button>
            </td>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in creatorItems" :key="item._id">
            <td>{{ index+1 }}</td>
            <td>
              <b-form-checkbox
                v-model="bulkCreatorIds"
                :value="item._id"
              />
            </td>
            <td>{{ item.name }}</td>
            <td>
              <b-form-checkbox
                v-model="gameSettings[item._id].isAvailable"
                name="check-button"
                switch
                :class="[gameSettings[item._id].isAvailable ? 'text-success' : 'text-danger']">
                  {{ gameSettings[item._id].isAvailable ? 'เปิด' : 'ปิด' }}
                </b-form-checkbox>
            </td>
            <td>
              <b-form-select
                style="width: 120px;"
                v-model="gameSettings[item._id].shareHolder.receive"
                :disabled="!gameSettings[item._id].isAvailable"
                :options="shareOptions"
                size="sm"
              ></b-form-select>
            </td>
            <td class="text-center">
              <div class="d-flex justify-content-center">
                <b-form-input
                  size="sm"
                  style="width: 120px;"
                  v-model="gameSettings[item._id].shareHolder.commission"
                  :disabled="!gameSettings[item._id].isAvailable"
                  type="number"
                  :number="true"
                >
                </b-form-input>
              </div>
            </td>
            <td></td>
          </tr>
          <tr v-if="!creatorItems.length">
            <td colspan="8" class="text-center">ไม่มีข้อมูล</td>
          </tr>
        </tbody>
      </table>

      <div class="p-2 text-right">
        <button class="btn btn-danger mr-2" @click="resetChanged">Reset</button>
        <button class="btn btn-success" @click="saveChanged">บันทึกการตั้งค่า</button>
      </div>
    </div>
  </b-modal>
</template>
<script>
import GameService from '@/services/gameService'
import Swal from 'sweetalert2'

export default {
  name: 'SetGameModal',
  props: {
    isShow: {
      type: Boolean,
      default: false
    },
    account: {
      type: Object,
      default: () => {
        return null
      }
    },
    catId: {
      type: String,
      default: null
    },
    categories: {
      type: Array,
      default: () => {
        return []
      }
    },
    creators: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {
      setCatId: null,
      gameSettings: {},
      needReload: false,
      checkAll: false,
      bulkCreatorIds: [],
      bulkData: {
        isAvailable: null,
        shareHolder: {
          receive: 100,
          referral: 0,
          over: false,
          commission: 0
        }
      },
      checkedShareHolder: false,
      checkedCommission: false
    }
  },
  computed: {
    title() {
      if(!this.account)
        return ''

      return `ตั้งค่าเกม [${this.account.user.username}]`
    },
    creatorItems() {
      return this.creators.filter((cre)=>{
        return cre.status === 'Active' && cre.catId === this.setCatId
      })
    },
    statusOptions() {
      return [
        { text: 'ไม่ตั้งค่า', value: null },
        { text: 'เปิด', value: true },
        { text: 'ปิด', value: false }
      ]
    },
    shareOptions() {
      let sharePercents = []
      for(let i=100; i>=0; i-=0.5) {
        sharePercents.push({
          text: i.toFixed(1),
          value: i
        })
      }
      return sharePercents
    }
  },
  watch: {
    isShow() {
      if(this.isShow){
        this.showModal()
      }else{
        this.hideModal()
      }
    },
    account() {
      console.log('account changed!!!')
      this.gameSettings = JSON.parse(JSON.stringify(this.account.gameSettings))
    },
    checkAll(n, o) {
      this.bulkCreatorIds = []
      if(n){
        for(const item of this.creatorItems) {
          this.bulkCreatorIds.push(item._id)
        }
      }
    },
    setCatId() {
      this.bulkCreatorIds = []
      this.checkAll = false
      this.checkedShareHolder = false
      this.checkedCommission = false
      this.bulkData = {
        isAvailable: null,
        shareHolder: {
          receive: 100,
          referral: 0,
          over: false,
          commission: 0
        }
      }
    }
  },
  methods: {
    setData() {
      this.setCatId = this.catId
      this.gameSettings = JSON.parse(JSON.stringify(this.account.gameSettings))
      this.bulkCreatorIds = []
      this.checkAll = false
      this.checkedShareHolder = false
      this.checkedCommission = false
      this.bulkData = {
        isAvailable: null,
        shareHolder: {
          receive: 100,
          referral: 0,
          over: false,
          commission: 0
        }
      }
    },
    resetModal() {
      this.needReload = false
    },
    showModal() {
      this.$refs['account-game-modal'].show()
    },
    hideModal() {
      this.$refs['account-game-modal'].hide()
    },
    saveBulk() {

      let updateData = {}
      if(this.bulkData.isAvailable !== null) {
        updateData['isAvailable'] = this.bulkData.isAvailable
      }

      if(this.checkedShareHolder || this.checkedCommission) {
        updateData['shareHolder'] = {}

        if(this.checkedShareHolder) {
          updateData['shareHolder']['receive'] = this.bulkData.shareHolder.receive
          updateData['shareHolder']['referral'] = (100 - this.bulkData.shareHolder.receive)
        }

        if(this.checkedCommission) {
          updateData['shareHolder']['commission'] = this.bulkData.shareHolder.commission || 0
        }
      }

      if(!Object.keys(updateData).length)
        return

      const data = {
        accountIds: [this.account.accountId],
        update: this.bulkCreatorIds.reduce((obj, creId)=>{
          obj[creId] = updateData
          return obj
        }, {})
      }

      this.updateCreator(data)
    },
    updateCreator(data) {
      GameService.updateCreatorSettings(data)
      .then((response)=>{
        if(!response.success) {
          throw new Error(response.data)
        }
      })
      .catch((e)=>{
        Swal.fire({
          title: 'ไม่สำเร็จ!',
          text: e.message,
          icon: 'error',
          confirmButtonText: 'OK'
        })
      })
      .finally(()=>{
        this.needReload = true
        this.hideModal()
      })
    },
    resetChanged() {
      this.gameSettings = JSON.parse(JSON.stringify(this.account.gameSettings))
    },
    findDifferences(obj1, obj2) {
      const differences = {};

      function compareObjects(o1, o2, res) {
        for (let key in o1) {
          if (o1.hasOwnProperty(key)) {
            if (typeof o1[key] === 'object' && o1[key] !== null && typeof o2[key] === 'object' && o2[key] !== null) {
              res[key] = {};
              compareObjects(o1[key], o2[key], res[key]);
              // Remove empty objects
              if (Object.keys(res[key]).length === 0) {
                delete res[key];
              }
            } else if (o1[key] !== o2[key]) {
              res[key] = o2[key];
            }
          }
        }
        for (let key in o2) {
          if (o2.hasOwnProperty(key) && !o1.hasOwnProperty(key)) {
            res[key] = o2[key];
          }
        }
      }

      compareObjects(obj1, obj2, differences);
      return differences;
    },
    saveChanged() {
      const changeData = this.findDifferences(this.account.gameSettings, this.gameSettings)

      if (!Object.keys(changeData).length)
        return

      const data = {
        accountIds: [this.account.accountId],
        update: changeData
      }

      this.updateCreator(data)
    }
  },
  mounted() {
    this.$root.$on('bv::modal::hide', (bvEvent, modalId) => {
      this.$emit('close', this.needReload)
    })
  }
}
</script>
<style lang="scss">
#account-game-modal {
  .card {
    .card-header {
      border-color: #86cfda;

      .nav-tabs {
        .nav-item {
          .nav-link {
            &.active {
              background-color: #BEE5EB;
              font-weight: bold;
              color: #007bff;
              border-color: #86cfda;
            }
          }
        }
      }
    }
  }

  .table {
    border-top: 0;

    thead {
      tr {

        th:first-child, td:first-child {
          border-left: 0;
        }

        th:last-child, td:last-child {
          border-right: 0;
        }

        th {
          border-top: 0px;
          vertical-align: middle;
          font-weight: normal;
          text-align: center;
        }

        td {
          vertical-align: middle;
          font-weight: normal;
          text-align: center;
        }
      }
    }

    tbody {
      background-color: #FFFFFF;
      tr {
        th:first-child, td:first-child {
          border-left: 0;
        }

        th:last-child, td:last-child {
          border-right: 0;
        }

        td {
          vertical-align: middle;
          text-align: center;
        }
      }
    }
  }
}
</style>
